/* Keep TA Labels & Badges on the first product image only (product pages). */
(function () {
  function run() {
    var slideshow = document.querySelector('.product-slideshow');
    if (!slideshow) return;
    var medias = slideshow.querySelectorAll('.product-media');
    var first = null;
    for (var i = 0; i < medias.length; i++) {
      if (!medias[i].closest('.slick-cloned')) { first = medias[i]; break; }
    }
    var labels = document.querySelectorAll('.bss_pl_img');
    for (var j = 0; j < labels.length; j++) {
      var l = labels[j];
      if (!l.closest('.product-slideshow') && !l.closest('.thumbnails')) continue; // leave related products, cards, etc.
      var keep = !!(first && first.contains(l) && l.closest('.product-slideshow'));
      if (!keep) {
        if (l.style.getPropertyValue('display') !== 'none' || l.style.getPropertyPriority('display') !== 'important') {
          l.style.setProperty('display', 'none', 'important');
        }
      }
    }
  }
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 60); }
  function start() {
    if (!document.querySelector('.product-slideshow')) return;
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();